<h1>
    <span *ngIf="!machine_id">Add Machine</span>
    <span *ngIf="machine_id">Update Machine</span>
    <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
</h1>
<form [formGroup]="machineForm" (submit)="createMachine()">
    <div class="form-group">
        <div class="row">
            <div class="col-sm-12">
                <label class="form-label">Machine Name *</label>
                <input type="text" formControlName="machine_name" class="form-control" />
                <div *ngIf="submitted && f.machine_name.errors" class="invalid-feedback">
                    <div *ngIf="f.machine_name.errors.required">Machine is required</div>
                </div>
            </div>
        </div>
    </div><br>
    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
            class="fa fa-spin fa-spinner"></i>
        <span *ngIf="!machine_id">Create Machine</span>
        <span *ngIf="machine_id">Update Machine</span>
    </button>
</form>